var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLesson(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 397.915,
    cy: 97.615,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.046,
    cy: 97.615,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.177,
    cy: 97.615,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.759 59.469h-481.518c-8.404 0-15.241 6.837-15.241 15.241v362.58c0 8.404 6.837 15.241 15.241 15.241h218.259c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-218.259c-.133 0-.241-.108-.241-.241v-29.185h482v29.185c0 .133-.108.241-.241.241h-233.259c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h233.259c8.404 0 15.241-6.837 15.241-15.241v-362.58c0-8.404-6.837-15.241-15.241-15.241zm-481.759 76.292h147.174c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-147.174v-46.051c0-.133.108-.242.241-.242h481.518c.133 0 .241.108.241.242v46.05h-304.826c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h83.998v257.344h-261.172zm276.171 257.344v-257.344h205.829v257.344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.758 241.018c-.156-.084-.315-.162-.477-.235l-86.479-38.855c-7.292-3.811-15.931-3.811-23.223 0l-86.479 38.855c-.162.073-.321.151-.478.235-4.247 2.283-6.793 6.695-6.646 11.514s2.958 9.067 7.335 11.087l30.973 14.291v45.853c0 4.319 2.586 8.159 6.587 9.783l10.257 4.163c16.146 6.553 33.106 9.829 50.069 9.829 16.98 0 33.964-3.284 50.123-9.851l10.192-4.142c4-1.626 6.584-5.465 6.584-9.782v-45.854l30.973-14.291c4.378-2.02 7.188-6.268 7.335-11.087.148-4.818-2.399-9.229-6.646-11.513zm-46.66 79.758-7.423 3.017c-28.662 11.647-60.235 11.655-88.904.02l-7.486-3.039v-35.941l41.404 19.104c3.337 1.54 6.92 2.31 10.502 2.31 3.583 0 7.165-.77 10.503-2.31l41.404-19.104zm-47.688-30.46c-2.679 1.237-5.755 1.237-8.437 0l-82.644-38.133 81.619-36.672c.162-.073.321-.151.477-.235 2.984-1.605 6.549-1.605 9.533 0 .156.084.315.162.477.235l81.62 36.672z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.011,
    cy: 178.401,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.011,
    cy: 222.137,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.011,
    cy: 265.873,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.011,
    cy: 309.609,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.011,
    cy: 353.344,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.625 185.901h104.92c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-104.92c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.546 214.637h-104.92c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h104.92c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.546 258.373h-104.92c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h104.92c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.546 302.109h-104.92c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h104.92c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.546 345.844h-104.92c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h104.92c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLesson);
export default __webpack_public_path__ + "static/media/icon-lesson.ef814a26.svg";
export { ForwardRef as ReactComponent };